import axios from 'axios';


const axiosClient = axios.create({
  baseURL: 'https://new.proschoolerp.com/api',
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});
 
export default axiosClient;